import React from "react";
import { Link } from "gatsby";
import { LANDING, SIGN_IN } from "../../../../constants/routes";
import Logo from "../../../../assets/icon.png";

const NavigationNonAuth = () => (
  <div className="navbar">
    <div className="navbar__inner">
      <div className="navbar__left">
        <div className="navbar__logo">
          <Link to={LANDING}>
            <img src={Logo} alt="logo" />
          </Link>
        </div>
        <div className="navbar__links">
          <div className="navbar__link">
            <Link to={SIGN_IN}>Sign In</Link>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default NavigationNonAuth;
